const dablena = (event, payload) => {
  window.dablena('track', event, payload);
};

export default dablena;
